export interface Testimonial {
  name: string;
  city: string;
  quote: string;
}

export interface Tomo {
  n: number;
  color: string;
  title: string;
  desc: string;
}

export interface Bono {
  n: number;
  title: string;
  desc: string;
  price: string;
  mockup: string;
}

export interface PricingOption {
  id: 'megapack';
  name: string;
  description: string;
  price: string;
  checkoutUrl: string;
}

export const PRODUCT_NAME = 'Megapack Danza Clásica Pro';

export const HERO_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/1cvw3Dn3gp6PN5EBBnoMHp/b290c002-5620-4dfb-a470-0331d96861b7.webp';

export const HERO_FEATURES: { icon: string; label: string }[] = [
  { icon: '📄', label: '100% DIGITAL' },
  { icon: '⚡', label: 'Acceso en 5 min' },
  { icon: '🎯', label: 'Todo nivel' },
  { icon: '📅', label: 'Todo el año' },
];

export const COST_STATS: { value: string; unit: string; title: string; desc: string }[] = [
  {
    value: '52',
    unit: 'domingos',
    title: 'Planificando a último momento',
    desc: 'Un año entero organizando la clase de la semana en vez de descansar.',
  },
  {
    value: '90',
    unit: 'minutos',
    title: 'Por cada clase que preparás',
    desc: 'Buscar ejercicios, elegir música y ordenar barra y centro come tu semana.',
  },
  {
    value: '1',
    unit: 'de cada 3',
    title: 'Alumnas que se van',
    desc: 'Las clases repetitivas son la razón más común por la que dejan de venir.',
  },
];

export const PAIN_CARDS: { title: string; desc: string }[] = [
  {
    title: 'Llegás con la clase a medio preparar',
    desc: 'Tenés la idea general, pero te falta ordenar ejercicios, elegir la música y definir qué trabajar.',
  },
  {
    title: 'Repetís las mismas combinaciones',
    desc: 'No tenés tiempo de preparar variantes con un objetivo claro, así que reciclás lo de siempre.',
  },
  {
    title: 'Perdés horas buscando música',
    desc: 'Encontrás una canción linda, pero no encaja con el ejercicio, el tempo o la duración.',
  },
  {
    title: 'Tenés niveles mezclados',
    desc: 'Iniciación y avanzadas en la misma sala, sin material adaptado.',
  },
  {
    title: 'Te cuesta conectar una clase con la siguiente',
    desc: 'Entre tantos grupos y horarios, se vuelve difícil registrar qué trabajaste y cómo seguir.',
  },
  {
    title: 'Trabajás los fines de semana',
    desc: 'Muestras, ensayos y planificación: el descanso se te va en organizar lo que viene.',
  },
];

export const PILLARS: { n: number; title: string; desc: string }[] = [
  {
    n: 1,
    title: 'Material listo',
    desc: 'Planificaciones, ejercicios de barra y centro y combinaciones armadas para aplicar tal cual están.',
  },
  {
    n: 2,
    title: 'Elegís y aplicás',
    desc: 'Buscás el tomo que necesitás, imprimís o abrís el PDF y das la clase.',
  },
  {
    n: 3,
    title: 'Te queda para siempre',
    desc: 'Acceso digital de por vida, con actualizaciones incluidas sin costo extra.',
  },
];

export const TOMOS: Tomo[] = [
  {
    n: 1,
    color: '#D9BD8A',
    title: 'Planificación Profesional de Clases',
    desc: 'Estructura completa, objetivos y tiempos: de la barra al centro y a las variaciones.',
  },
  {
    n: 2,
    color: '#E8C9CB',
    title: 'Barra y Centro: Ejercicios y Combinaciones',
    desc: 'Secuencias de barra, adagio, allegro y diagonales listas para cada nivel.',
  },
  {
    n: 3,
    color: '#C99AA3',
    title: 'Música y Musicalidad para Clase',
    desc: 'Cómo elegir tempo, compás y duración para que cada ejercicio fluya con la música.',
  },
  {
    n: 4,
    color: '#EAD7B0',
    title: 'Niveles, Adaptaciones y Manejo de Grupos',
    desc: 'Ajustes para iniciación, principiante e intermedio, y estrategias para grupos mixtos.',
  },
  {
    n: 5,
    color: '#B97F8F',
    title: 'Muestras, Ensayos y Eventos Especiales',
    desc: 'Organización de muestras de fin de año, ensayos y jornadas especiales.',
  },
  {
    n: 6,
    color: '#F2E2E2',
    title: 'Crecimiento Profesional para Profesoras',
    desc: 'Imagen, promoción, organización de horarios y comunidad para tu estudio.',
  },
];

export const TOMO_INCLUDES: string[] = [
  'Contenido listo para aplicar en clase',
  'Ideas adaptables a distintos niveles',
  'Material 100% digital y descargable',
  'Actualizado y pensado para profesoras reales',
];

export const BONOS: Bono[] = [
  {
    n: 1,
    title: 'Iniciación Kids: Clases Listas para Niñas y Niños',
    desc: 'Propuestas, juegos y dinámicas para dar clases infantiles con confianza.',
    price: '$8.990',
    mockup: 'https://cdn.magicpatterns.com/patterns/generated-images/468fb8d3-624a-40fe-b7a8-1255c69c4099.jpg',
  },
  {
    n: 2,
    title: 'Calendario Anual de Clases y Muestras',
    desc: 'Un año entero de ideas para planificar fechas especiales, estaciones y muestras.',
    price: '$9.990',
    mockup: 'https://cdn.magicpatterns.com/patterns/generated-images/6e9c698b-466e-4a9a-bcc5-854ce7f4b990.jpg',
  },
  {
    n: 3,
    title: 'Planner Imprimible de Clases Mensuales',
    desc: 'Calendario, plan de clase y checklist listos para imprimir y organizar cada mes.',
    price: '$7.990',
    mockup: 'https://cdn.magicpatterns.com/patterns/generated-images/d02e55f6-cb1d-4977-ac50-240452c4c62c.jpg',
  },
  {
    n: 4,
    title: 'Guiones de WhatsApp para Vender Clases',
    desc: 'Mensajes probados para responder consultas, convertir interesadas y sumar alumnas.',
    price: '$8.990',
    mockup: 'https://cdn.magicpatterns.com/patterns/generated-images/1b4b1e45-50c1-4139-89aa-f816f1831f83.jpg',
  },
  {
    n: 5,
    title: '30 Ideas de Reels para Profes de Danza Clásica',
    desc: 'Ideas listas para crear contenido, ganar visibilidad y atraer más alumnas.',
    price: '$7.990',
    mockup: 'https://cdn.magicpatterns.com/patterns/generated-images/cde1a2c0-3534-4bef-8f8a-2345efae3863.jpg',
  },
];

export const VALUE_STACK: { label: string; detail: string; value: string; strike?: boolean }[] = [
  { label: PRODUCT_NAME, detail: '6 tomos completos', value: '$19.990' },
  { label: 'Bono 1 · Iniciación Kids', detail: 'Clases listas para niñas y niños', value: '$8.990', strike: true },
  { label: 'Bono 2 · Calendario anual', detail: 'Clases y muestras todo el año', value: '$9.990', strike: true },
  { label: 'Bono 3 · Planner imprimible', detail: 'Organización mensual', value: '$7.990', strike: true },
  { label: 'Bono 4 · Guiones de WhatsApp', detail: 'Para vender tus clases', value: '$8.990', strike: true },
  { label: 'Bono 5 · 30 ideas de Reels', detail: 'Contenido para crecer', value: '$7.990', strike: true },
];

export const FULL_TESTIMONIALS: Testimonial[] = [
  {
    name: 'Marina T.',
    city: 'Rosario',
    quote:
      'Antes armaba las clases a último momento y siempre estresada. Con el Megapack tengo la barra y el centro del mes listos y mis clases se llenaron de nuevo.',
  },
  {
    name: 'Carla G.',
    city: 'Córdoba',
    quote:
      'Los tomos de combinaciones y musicalidad me salvaron. Renové todo mi repertorio en una semana y las alumnas lo notaron enseguida.',
  },
  {
    name: 'Vicky R.',
    city: 'Mendoza',
    quote:
      'Lo que más valoro es el tiempo. Recuperé mis domingos y mis clases son más profesionales que nunca.',
  },
  {
    name: 'Sofía M.',
    city: 'La Plata',
    quote:
      'El bono de guiones de WhatsApp me ayudó a llenar mis horarios. Pasé de 2 grupos a 5 en tres meses. Recomendadísimo.',
  },
];

export const FAQS: { q: string; a: string }[] = [
  {
    q: '¿Sirve para todos los niveles?',
    a: 'Sí. Incluye propuestas de iniciación, principiante e intermedio, con ideas para adaptar cada ejercicio.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Por email, de forma inmediata después del pago, con los PDF listos para descargar.',
  },
  {
    q: '¿Necesito experiencia previa dando clases?',
    a: 'No. Los tomos están ordenados paso a paso para que puedas aplicarlos desde la primera clase.',
  },
  {
    q: '¿Puedo imprimir el material?',
    a: 'Sí, es 100% digital y descargable: podés abrirlo en pantalla o imprimirlo.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí, 7 días. Si no es lo que esperabas, te devolvemos el 100% de tu dinero.',
  },
];

export const PRICING_OPTIONS: PricingOption[] = [
  {
    id: 'megapack',
    name: PRODUCT_NAME,
    description: '6 Tomos + 5 Bonos',
    price: '$19.990',
    checkoutUrl: 'https://www.aulabailepro.store/checkout',
  },
];

export const PRICING = {
  currency: 'ARS',
  bonusValueOld: '$43.950',
  totalValueOld: '$63.940',
  savings: '$43.950',
};
